import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoDblClick]'
})
export class NoDblClickDirective {

  constructor() { }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    setTimeout(function() {
    event.srcElement.setAttribute('disabled', 'disabled');
    }, 0);

    setTimeout(function() {
      event.srcElement.removeAttribute('disabled');
    }, 400);
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/no-dbl-click/no-dbl-click.directive.ts